import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FnIconComponent } from './fn-icon.component';
import { FnFaIconComponent } from './parts/fa-icon/fn-fa-icon.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

export * from './fn-icon.component';
export * from './parts/fa-icon/fn-fa-icon.component';

/** 
 * Exports the required FnIconComponent and FnFaIconComponent to create icon and FountAwesome Icon.
 * making them available for import by NgModules that import this module.
 */
@NgModule({
    imports: [FormsModule, CommonModule],
    exports: [FnIconComponent, FnFaIconComponent],
    declarations: [FnIconComponent, FnFaIconComponent],
    providers: [],
    schemas: []
})
export class FnIconModule { }
